<template>
  <div id="home">
    <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal">
      <b-row>
        <b-col cols="12" class="start-containter titel-aktuell space-b2">
          <h1>Zeitschrift für feministische Politikwissenschaft</h1>
        </b-col>
      </b-row>
      <b-row v-for="entry in entries" :key="entry.uid">
        <b-col cols="12" class="news-aktuell border-t-primary space-t2 space-b-lg ">
          <h2>{{entry.title}}</h2>
          <div class="text-h3 add-link redactor-with-linkicon" v-html="newLineText(entry.aktuellText)"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Navigation from "@/components/_navigation";
const axios = require("axios");

export default {
  name: "home",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
  },
  data() {
    return {
      entries: [],
      navigationPlaceholder: "Aktuell"
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                 entries(section: "aktuell") {
                  title,
                  uid
                  ... on aktuell_aktuell_Entry {
                    aktuellText
                  }
                }
              }
            `,
      },
    }).then((result) => {
      let data = result.data.data.entries;
      console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;
    });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
</style>


